import { useNavigate } from "react-router-dom";
import logo from "../assets/images/logos/logo-long-transparent.svg";
import { useState } from "react";
import LoaderFull from "../components/LoaderFull";
import axios from "axios";
import axiosInstance from "../api/apiClient";
const Login = () => {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);

    const handleLogin = (e: React.FormEvent<HTMLFormElement>) => {

        e.preventDefault();
        setLoading(true);


        const formData = new FormData(e.currentTarget);
        const email = formData.get('username') as string;
        const password = formData.get('password') as string;
        console.log(email, password);


        const response = axiosInstance.post('auth/login', { email, password })
        .then((response:any) => {
            console.log(response);
            return response
        })
        .then((r:any) => {
            const user = r.user;
            console.log(r);
            localStorage.setItem('accessToken', r.accessToken);
            localStorage.setItem('refreshToken', r.refreshToken);
            localStorage.setItem('bibloUser', JSON.stringify(user));
            setLoading(false);
            navigate('/');
        })
        .catch((error:any) => {
            alert(error.message);
            setLoading(false);
        });

    }

    if (loading) {
      return <LoaderFull />
    }

    return (
        <div className="flex justify-center items-center">
           <div className="flex min-h-full flex-col justify-center px-6 py-12 lg:px-8">
  <div className="sm:mx-auto sm:w-full sm:max-w-sm">
    <img className="mx-auto h-auto w-[200px]" src={logo} alt="Biblo" />
    <h2 className="mt-10 text-center text-2xl/9 font-bold tracking-tight text-gray-900">Sign in to your account</h2>
  </div>

  <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
    <form className="space-y-6" onSubmit={(e) => handleLogin(e)}>
      <div>
        <label htmlFor="username" className="block text-sm/6 font-medium text-gray-900">Username</label>
        <div className="mt-2">
          <input id="username" name="username" type="text" autoComplete="username" required className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6 p-2"/>
        </div>
      </div>

      <div>
        <div className="flex items-center justify-between">
          <label htmlFor="password" className="block text-sm/6 font-medium text-gray-900">Password</label>
          <div className="text-sm">
            {/* <a href="#" className="font-semibold text-indigo-600 hover:text-indigo-500">Forgot password?</a> */}
          </div>
        </div>
        <div className="mt-2">
          <input id="password" name="password" type="password" autoComplete="current-password" required className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6 p-2"/>
        </div>
      </div>

      <div>
        <button type="submit" className="flex w-full justify-center rounded-md bg-[#7C939A] px-3 py-1.5 text-sm/6 font-semibold text-white shadow-sm hover:bg-[#57676c] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600">Sign in</button>
      </div>
    </form>
  </div>
</div>
        </div>
    );
}

export default Login;